module.exports = __webpack_public_path__ + "img/10050006.a3fd00cf.jpg";